import { render } from "./CasesLogs.vue?vue&type=template&id=2d606022"
import script from "./CasesLogs.vue?vue&type=script&lang=js"
export * from "./CasesLogs.vue?vue&type=script&lang=js"

import "./CasesLogs.vue?vue&type=style&index=0&id=2d606022&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/logs/CasesLogs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d606022"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d606022', __exports__)) {
    console.log('reload')
    api.reload('2d606022', __exports__)
  }
  
  module.hot.accept("./CasesLogs.vue?vue&type=template&id=2d606022", () => {
    console.log('re-render')
    api.rerender('2d606022', render)
  })

}


export default __exports__